import { render, staticRenderFns } from "./EmployeeSettings.vue?vue&type=template&id=355e86f6&scoped=true"
import script from "./EmployeeSettings.vue?vue&type=script&lang=js"
export * from "./EmployeeSettings.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSettings.vue?vue&type=style&index=0&id=355e86f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e86f6",
  null
  
)

export default component.exports